import(/* webpackMode: "eager" */ "/home/runner/work/agger-customer/agger-customer/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/home/runner/work/agger-customer/agger-customer/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/agger-customer/agger-customer/src/components/RootLayoutWrapper/index.tsx");
